export default {"src":"/_next/static/media/log-out.45d1a93e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};